<app-order-list
  [orderList]="orderList$ | async"
  [isMobile]="isMobile"
  (openDetailsModalClick)="openOrderModal($event)"
  (reloadTicketsAfterChange)="reloadTicketsAfterChange()"
  (loadMoreClick)="handleLoadMoreClick($event)"
  (paymentClick)="handlePaymentClick($event)" />
